/* Bean Stamps - storefront mount.

   Anchors are taken from the ACTUAL BeanBurds PDP section (bb-pdp-coffee),
   not a stock Shopify theme. The buy control is #atcBtn inside .cart-row
   inside .buybox; there is no form[action*="/cart/add"] because add-to-cart
   is JS-driven here. Guessing generic selectors made the module silently never
   appear, which is the worst possible failure for a loyalty widget - so the
   mount now reports to the console when it cannot find a home.

   Every failure is otherwise silent: this must never be the reason a product
   page breaks.

   GUESTS see a teaser: the empty card, the offer, and a sign-in link. They are
   exactly who the programme should recruit, so hiding it from them (the old
   pre-launch behaviour) is gone. Signed-in customers see their real card.

   NOTE: this preview build assembles the DOM client-side so QA can force a
   balance without a stamped account. The production theme app extension
   renders the same markup server-side, so there is no layout shift. */
(function () {
  'use strict';

  var stateEl = document.getElementById('bean-stamps-state');
  if (!stateEl) return;

  var state;
  try { state = JSON.parse(stateEl.textContent); } catch (e) { return; }
  if (!state) return;

  /* QA override: ?bean_stamps_preview=N. Display only, never trusted. */
  var preview = null;
  try {
    var raw = new URLSearchParams(window.location.search).get('bean_stamps_preview');
    if (raw !== null) {
      var n = parseInt(raw, 10);
      if (!isNaN(n)) preview = Math.max(0, Math.min(n, state.required || 8));
    }
  } catch (e) {}

  var guest = preview === null && !state.signedIn;
  var balance = preview === null ? (state.balance || 0) : preview;
  var required = state.required || 8;
  var ready = preview === null ? !!state.rewardReady : balance >= required;

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function buildGuestModule() {
    var root = el('aside', 'bstamp');
    root.setAttribute('aria-label', 'Bean Stamps loyalty programme');

    var top = el('div', 'bstamp__top');
    var head = el('div');
    head.appendChild(el('p', 'bstamp__kicker', 'Bean Stamps'));
    head.appendChild(el('h2', 'bstamp__title', 'Your 9th bag is free'));
    top.appendChild(head);
    root.appendChild(top);

    root.appendChild(el('p', 'bstamp__copy',
      'Collect a stamp for every coffee bag priced ' + (state.floorDisplay || 'AED 45') +
      ' or more. Fill all ' + required + ' and your next bag is on us, covered up to ' +
      (state.coverDisplay || 'AED 80') + '.'));

    var row = el('div', 'bstamp__row');
    row.setAttribute('role', 'img');
    row.setAttribute('aria-label', 'An empty card of ' + required + ' stamps');
    for (var i = 0; i < required; i++) {
      var dot = 'bstamp__dot';
      if (i === 0 && state.qualifies) dot += ' bstamp__dot--pending';
      var d = el('span', dot);
      d.setAttribute('aria-hidden', 'true');
      row.appendChild(d);
    }
    root.appendChild(row);

    var note = el('p', 'bstamp__note');
    var cta = el('a', 'bstamp__cta', 'Sign in to start collecting');
    cta.href = '/account/login';
    if (state.qualifies) {
      note.appendChild(document.createTextNode('This bag would be your first stamp. '));
    } else {
      note.appendChild(document.createTextNode(
        'This item doesn’t earn a stamp — coffee bags ' +
        (state.floorDisplay || 'AED 45') + '+ do. '));
    }
    note.appendChild(cta);
    root.appendChild(note);

    return root;
  }

  function buildModule() {
    if (guest) return buildGuestModule();

    var cls = 'bstamp';
    if (ready) cls += ' bstamp--ready';
    else if (!state.qualifies) cls += ' bstamp--quiet';

    var root = el('aside', cls);
    root.setAttribute('aria-label', 'Bean Stamps progress');

    var top = el('div', 'bstamp__top');
    var head = el('div');
    head.appendChild(el('p', 'bstamp__kicker', 'Bean Stamps'));

    var title;
    if (ready) title = 'A free bag is waiting';
    else if (state.qualifies) title = balance + ' of ' + required + ' · this bag makes ' + (balance + 1);
    else title = 'This bag doesn’t add a stamp';
    head.appendChild(el('h2', 'bstamp__title', title));
    top.appendChild(head);
    root.appendChild(top);

    var copy;
    if (ready) copy = 'Your next bag is on us, covered up to ' + (state.coverDisplay || 'AED 80') + '.';
    else if (state.qualifies) copy = 'Every qualifying bag gets its own stamp. Quantity counts too.';
    else copy = 'Bean Stamps count coffee bags priced ' + (state.floorDisplay || 'AED 45') +
                ' or more. This lovely bag stays exactly as it is.';
    root.appendChild(el('p', 'bstamp__copy', copy));

    var row = el('div', 'bstamp__row');
    row.setAttribute('role', 'img');
    row.setAttribute('aria-label', balance + ' of ' + required + ' stamps collected');
    for (var i = 0; i < required; i++) {
      var dot = 'bstamp__dot';
      if (i < balance) dot += ' bstamp__dot--filled';
      else if (i === balance && state.qualifies && !ready) dot += ' bstamp__dot--pending';
      var d = el('span', dot);
      d.setAttribute('aria-hidden', 'true');
      row.appendChild(d);
    }
    root.appendChild(row);

    var note;
    if (ready) note = 'Ready to redeem after this order.';
    else if (state.qualifies) {
      var left = required - balance - 1;
      note = left <= 0 ? 'This order completes your card.'
                       : left + ' more bag' + (left === 1 ? '' : 's') + ' after this order.';
    } else note = 'Your card stays at ' + balance + ' of ' + required + '.';
    root.appendChild(el('p', 'bstamp__note', note));

    return root;
  }

  /* Real anchors, verified against the rendered PDP. Ordered most precise
     first; each one places the module directly under the buy row. */
  function findPdpAnchor() {
    var buyRow = document.querySelector('.buybox .cart-row') ||
                 document.querySelector('.pdp .cart-row') ||
                 document.querySelector('.cart-row');
    if (buyRow) return { node: buyRow, how: 'afterend' };

    var btn = document.getElementById('atcBtn');
    if (btn) {
      var row = btn.closest ? (btn.closest('.cart-row') || btn.parentElement) : btn.parentElement;
      if (row) return { node: row, how: 'afterend' };
    }

    var buybox = document.querySelector('.buybox');
    if (buybox) return { node: buybox, how: 'beforeend' };

    return null;
  }

  function mountPdp() {
    if (!state.isProduct || document.querySelector('.bstamp')) return;
    var target = findPdpAnchor();
    if (!target) {
      if (window.console && console.warn) {
        console.warn('[bean-stamps] no PDP anchor found; module not shown');
      }
      return;
    }
    var mod = buildModule();
    if (target.how === 'afterend') target.node.insertAdjacentElement('afterend', mod);
    else target.node.appendChild(mod);
  }

  var PAGE_URL = state.pageUrl || '/pages/bean-stamps';

  /* The header surfaces — the desktop pill and the mobile bar — are rendered
     by snippets/bean-stamps-nav, not from here. They arrive with the HTML, so
     they never shift the page and they survive JavaScript being off.

     The one thing markup alone cannot decide is WHEN the ring should animate.
     A CSS-only draw-in would replay on every page load, which turns a moment of
     delight into a tic by the third product page. So the class that enables the
     animation is added once per browsing session and then remembered.

     sessionStorage can throw outright in private modes and locked-down
     browsers, so every access is guarded; if it fails we simply skip the
     animation rather than break the header. */
  var RING_SEEN = 'bb_stamp_ring_seen';

  function ringSeen() {
    try { return sessionStorage.getItem(RING_SEEN) === '1'; } catch (e) { return true; }
  }
  function markRingSeen() {
    try { sessionStorage.setItem(RING_SEEN, '1'); } catch (e) {}
  }

  function animateRingsOnce() {
    if (ringSeen()) return;
    var rings = document.querySelectorAll('.bsr__arc');
    if (!rings.length) { return; }   /* guest: nothing to draw, nothing to spend */
    for (var i = 0; i < rings.length; i++) {
      rings[i].parentNode.classList.add('bsr--draw');
    }
    markRingSeen();
  }

  function mountBadge() {
    try { animateRingsOnce(); } catch (e) {}
  }

  /* ---------------- collection tile ----------------------------------------
     The collection grid is rendered by the store's own JS and re-rendered on
     every filter or sort change, so the tile is inserted after each render and
     guarded against duplicates rather than written into the grid markup. That
     keeps this module entirely additive: nothing in bb-coffee.js or
     bb-collection-v5.js is touched, and removing the file removes the tile.

     Built to the card contract on purpose — same radius, same padding, same
     hairline — so it occupies one cell and stretches to the row height. Mint
     ground rather than the signature gradient: the collection hero already
     carries the page's one gradient moment, and a gradient tile here would
     outweigh the products beside it. */
  var MIN_PRODUCTS_BEFORE = 3; /* let the shopper see real coffee first */

  function buildTile() {
    var a = el('a', 'card bb-card-v10 bstamp-tile');
    a.href = PAGE_URL;

    var pad = el('div', 'bstamp-tile__pad');
    var body = el('div', 'bstamp-tile__body');
    body.appendChild(el('p', 'bstamp-tile__eyebrow', 'Bean Stamps'));
    body.appendChild(el('h3', 'bstamp-tile__title', 'Your ' + (required + 1) + 'th bag is free'));
    body.appendChild(el('p', 'bstamp-tile__copy',
      'A stamp for every bag of coffee. Fill the card and the next one is on us.'));

    var row = el('div', 'bstamp-tile__row');
    row.setAttribute('role', 'img');
    row.setAttribute('aria-label', balance + ' of ' + required + ' stamps collected');
    for (var i = 0; i < required; i++) {
      var d = el('span', 'bstamp-tile__dot' + (i < balance ? ' bstamp-tile__dot--on' : ''));
      d.setAttribute('aria-hidden', 'true');
      row.appendChild(d);
    }
    body.appendChild(row);
    pad.appendChild(body);
    a.appendChild(pad);

    var foot = el('div', 'bstamp-tile__foot');
    foot.appendChild(el('span', 'bstamp-tile__link',
      guest ? 'See how it works' : balance + ' of ' + required + ' collected'));
    var arrow = el('span', 'bstamp-tile__arrow', '→');
    arrow.setAttribute('aria-hidden', 'true');
    foot.appendChild(arrow);
    a.appendChild(foot);

    return a;
  }

  function findGrid() {
    return document.querySelector('#bbc-app .bbc-grid') ||
           document.querySelector('.bbc-root .bbc-grid') ||
           document.querySelector('.bbc-grid');
  }

  function mountTile() {
    if (!state.showTile) return;
    var grid = findGrid();
    if (!grid) return;
    /* List view stacks rows at a completely different scale; a tile shaped for
       the grid would dominate there, so it only rides the grid. */
    if (grid.classList.contains('bbc-grid--list')) {
      var existing = grid.querySelector('.bstamp-tile');
      if (existing) existing.remove();
      return;
    }
    if (grid.querySelector('.bstamp-tile')) return;

    var kids = [].slice.call(grid.children);
    var isProductCard = function (n) {
      return n && n.classList.contains('card') && !!n.querySelector('.buy, .price');
    };
    if (kids.filter(isProductCard).length < MIN_PRODUCTS_BEFORE + 1) return;

    /* The collection already places its own promos (.insert, .xsell) at fixed
       slots. Dropping ours beside one of those turns a shopping row into a
       block of adverts, so take the earliest slot whose neighbours on both
       sides are real product cards — and only after a few products have been
       seen. If the grid offers no such slot, append rather than force one. */
    var target = null, seen = 0;
    for (var i = 0; i < kids.length; i++) {
      if (isProductCard(kids[i])) seen++;
      if (seen >= MIN_PRODUCTS_BEFORE &&
          isProductCard(kids[i]) && isProductCard(kids[i + 1])) {
        target = kids[i + 1];
        break;
      }
    }

    var tile = buildTile();
    if (target) grid.insertBefore(tile, target);
    else grid.appendChild(tile);
  }

  var tileTimer = null;
  function scheduleTile() {
    if (tileTimer) return;
    tileTimer = setTimeout(function () {
      tileTimer = null;
      try { mountTile(); } catch (e) {}
    }, 60);
  }

  function watchGrid() {
    if (!state.showTile) return;
    var root = document.querySelector('#bbc-app') || document.querySelector('.bbc-root') || document.body;
    if (!root || !window.MutationObserver) return;
    new MutationObserver(scheduleTile).observe(root, { childList: true, subtree: true });
  }

  function init() {
    try { mountPdp(); } catch (e) {}
    try { mountBadge(); } catch (e) {}
    try { mountTile(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pageshow', init);
  watchGrid();
})();
